import { useIntl } from "react-intl";
import { Button } from "~/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";

interface RegenerateReportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  reportName?: string;
}

export function RegenerateReportModal({
  isOpen,
  onClose,
  onConfirm,
  reportName = "Independent Medical Examination",
}: RegenerateReportModalProps) {
  const { formatMessage } = useIntl();

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {formatMessage({ id: "reportArea.regenerateModal.title" })}
          </DialogTitle>
          <DialogDescription>
            {formatMessage(
              { id: "reportArea.regenerateModal.description" },
              {
                reportName: <strong>{reportName}</strong>,
              }
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            {formatMessage({ id: "cancel" })}
          </Button>
          <Button onClick={onConfirm}>
            {formatMessage({ id: "reportArea.regenerateModal.confirm" })}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
